export const WALLET_TYPES = [
    { key: 'proton', value: 'Mobile' },
    { key: 'webauth', value: 'Browser' },
    { key: 'anchor', value: 'Desktop' },
]